import { openHeroVideo } from '../blocks/index-hero'

window.setupButtonAnimation = () => {

  const hoverBtn = $('.c-btn-hover ')
  const $body = $('body')
  if(!hoverBtn.length) return false

  // $(window).on('load', function () {

    hoverBtn.each(function () {

      let btnWidth = $(this).outerWidth()
      let btnHeight = $(this).outerHeight()
      let svg = $(this).find('.svg-rect')
      let rect = $(this).find('.svg-rect rect')

      let dashArray = btnWidth + btnHeight
      let dashOffset = -(btnWidth / 2)
      let dashOffsetHover = - (btnWidth / 2) - (btnWidth * 2) - (btnHeight * 2)

      svg.attr('data-default', dashOffset)
      svg.attr('data-hover', dashOffsetHover)
      svg.attr('width', btnWidth)
      svg.attr('height', btnHeight)
      svg.css({strokeDasharray: `0 ${dashArray} ${dashArray} 0`, strokeDashoffset: `${dashOffset}`})
      rect.attr('width', btnWidth)
      rect.attr('height', btnHeight)

    })

  // })

  $body.on('mouseenter', '.c-btn-on-hover', function () {
    let svg = $(this).find('.svg-rect')
    let hoverVal = svg.attr('data-hover')
    svg.css({ strokeDashoffset: hoverVal })
  })

  $body.on('mouseleave', '.c-btn-on-hover', function () {
    let svg = $(this).find('.svg-rect')
    let hoverVal = svg.attr('data-default')
    svg.css({ strokeDashoffset: hoverVal })
  })


  $body.on('click', '.c-btn-on-click', function (e) {
    e.preventDefault()
    let svg = $(this).find('.svg-rect')
    let hoverVal = svg.attr('data-hover')
    let defaultVal = svg.attr('data-default')

    svg.css({ strokeDashoffset: hoverVal, transition: 'all 1s' })

    setTimeout(function () {
      svg.css({ strokeDashoffset: defaultVal, transition: 'none' })
    }, 1050)

  })

}

function buttonHoverClick(buttonClass) {

  const button = $(buttonClass)

  let svg = button.find('.svg-rect')
  let hoverVal = svg.attr('data-hover')
  let defaultVal = svg.attr('data-default')

  svg.css({ strokeDashoffset: hoverVal, transition: 'all 1s' })

  setTimeout(function () {
    svg.css({ strokeDashoffset: defaultVal, transition: 'none' })
  }, 1050)

}

document.addEventListener('DOMContentLoaded', function () {
    setupButtonAnimation()
});

export { buttonHoverClick }
